export default __webpack_public_path__ + "static/media/shuffle-pack-1.217144df.png";